export const USER_DELETE_RESPONSE_CODE = {
  HAS_OPEN_ASSIGNMENTS: "INTERNAL-USER-HAS-OPEN-ASSIGNMENTS",
  HAS_PENDING_ASSIGNMENTS: "INTERNAL-USER-HAS-PENDING-ASSIGNMENTS"
} as const;

export const USER_DELETE_HANDLED_CODES: readonly string[] = Object.values(USER_DELETE_RESPONSE_CODE);
